module.exports = __webpack_public_path__ + "img/pointE_screen.0bf675fa.png";